import Jukie from '@/views/Jukie.vue';
import eventRoutes from '@/router/routes/jukie/events';
import configurazionWizardRoutes from '@/router/routes/jukie/configurazionWizard';
import spotifyAuthorizationRoutes from '@/router/routes/jukie/spotifyAuthorization';

export default [
  {
    path: '/',
    name: 'jukie',
    component: Jukie,
    meta: {
      requiresAuth: true,
    },
    children: [
      ...eventRoutes,
      ...configurazionWizardRoutes,
      ...spotifyAuthorizationRoutes,
    ],
  },

];
